"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_SIZE_LIMITS = exports.COLLECTION_PLACEHOLDER_IMAGE = exports.PAGE_PLACEHOLDER_IMAGE = exports.USER_PLACEHOLDER_IMAGE = exports.RESET_LINK_EXPIRY_HOURS = exports.CODE_EXPIRY_MINUTES = void 0;
exports.CODE_EXPIRY_MINUTES = 10;
exports.RESET_LINK_EXPIRY_HOURS = 2;
exports.USER_PLACEHOLDER_IMAGE = "/images/users/placeholder.png";
exports.PAGE_PLACEHOLDER_IMAGE = "/images/pages/placeholder.svg";
exports.COLLECTION_PLACEHOLDER_IMAGE = "/images/collection-placeholder.svg";
exports.FILE_SIZE_LIMITS = {
    PAGE_PHOTO: 25 * 1000 * 1000,
    BODY_IMAGE: 25 * 1000 * 1000,
    USER_PHOTO: 25 * 1000 * 1000,
    COLLECTION_PHOTO: 25 * 1000 * 1000,
    ATTACH_FILE: 50 * 1000 * 1000, // 50 MB
};
